module.exports = __webpack_public_path__ + "static/media/class4.ff92422f.jpg";